import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import {
  BootstrapVue,
  IconsPlugin,
  PopoverPlugin,
  TooltipPlugin
} from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "./assets/style.css";
import Notification from "@/components/Notification.vue";
import VueTimeago from "vue-timeago";

Vue.use(VueTimeago, {
  name: "Timeago", // Component name, `Timeago` by default
  locale: "en" // Default locale
});
// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
Vue.use(PopoverPlugin);
Vue.use(TooltipPlugin);
Vue.use(Notification);

Vue.config.productionTip = false;

// load config and then initialize the app
window
  .fetch(process.env.BASE_URL + "config/config.json")
  .then(r => r.json())
  .then(j => (window.app_config = j))
  .then(function() {
    window.vm = new Vue({
      router,
      render: h => h(App)
    }).$mount("#app");
  });
